import { render } from "./Participantes.vue?vue&type=template&id=558f06f5"
import script from "./Participantes.vue?vue&type=script&lang=js"
export * from "./Participantes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__